<template>
  <div class="default-layout">
    <!-- Skip links (tarea 15.5.4) -->
    <a href="#main-content" class="skip-link">Saltar al contenido principal</a>
    <a href="#main-nav" class="skip-link">Saltar al menú de navegación</a>

    <Navbar id="main-nav" />
    <main id="main-content" class="content" tabindex="-1">
      <slot></slot>
    </main>

    <!-- Panel de accesibilidad flotante (Issue #44) -->
    <AccessibilityPanel />

    <!-- Búsqueda global (Issue #48) -->
    <GlobalSearch ref="globalSearchRef" />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import Navbar from './Navbar.vue';
import AccessibilityPanel from '../financial/AccessibilityPanel.vue';
import GlobalSearch from '../financial/GlobalSearch.vue';
import { useAccessibility } from '../../composables/financial/useAccessibility';

const globalSearchRef = ref(null);

// Ctrl+K → abrir GlobalSearch (tarea 17.1.2)
useAccessibility({
  onOpenSearch: () => globalSearchRef.value?.openSearch(),
});
</script>

<style>
/* ── Focus visible global (tarea 15.5.2) ── */
:focus-visible {
  outline: 3px solid var(--primary-color, #6366f1) !important;
  outline-offset: 2px !important;
  border-radius: 4px;
}

/* ── Alto contraste (tarea 15.7.2) ── */
.high-contrast {
  filter: contrast(1.5) saturate(0.8);
}

/* ── Reducir movimiento (tarea 15.7.3) ── */
.reduce-motion *,
.reduce-motion *::before,
.reduce-motion *::after {
  animation-duration: 0.001ms !important;
  transition-duration: 0.001ms !important;
}
</style>

<style scoped>
.default-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.content {
  flex: 1;
  padding: 1rem;
  outline: none;
}

/* ── Skip links (tarea 15.5.4) ── */
.skip-link {
  position: absolute;
  left: -9999px;
  top: 0.5rem;
  padding: 0.5rem 1rem;
  background: var(--primary-color, #6366f1);
  color: #fff;
  font-weight: 700;
  font-size: 0.875rem;
  border-radius: 0 0 0.5rem 0;
  z-index: 9999;
  text-decoration: none;
}
.skip-link:focus {
  left: 0.5rem;
  outline: 3px solid #fff;
  outline-offset: 2px;
}
</style>